import { render } from "./TomaFoto.vue?vue&type=template&id=5f6a7ac4"
import script from "./TomaFoto.vue?vue&type=script&lang=js"
export * from "./TomaFoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__